import { InjectionToken } from '@angular/core';
import type { ApiClient } from '@lance-x/api-client';

/**
 * DI token for the singleton ApiClient instance.
 * The provider lives in api-client.provider.ts and is registered in app.config.ts.
 */
export const API_CLIENT = new InjectionToken<ApiClient>('API_CLIENT');
